import React from 'react';
import { number } from 'prop-types';
import { connect } from 'react-redux';

import { SURVEY_GIZMO_URL } from '../../../actions/urlTypes';
import IEErrorMessage from '../IEErrorMessage';

const SurveyGizmoIframe = ({ gizmoSurveyId }) => {
  if (!gizmoSurveyId) {
    return (
      <IEErrorMessage message="Something went wront, Gizmo id not defined" />
    );
  }
  const surveyUrl = SURVEY_GIZMO_URL + gizmoSurveyId;
  return (
    <div className="ie--questions--container">
      <div className="ie--questions--header">
        <h3 className="ie--questions---title">Survey Questionnaire</h3>
      </div>
      <div className="ie--questions--iframe">
        <iframe
          id="embeddedSurveyIFrame"
          name="embeddedSurveyIFrame"
          src={surveyUrl}
        >
          {' '}
        </iframe>
      </div>
    </div>
  );
};

SurveyGizmoIframe.propTypes = {
  gizmoSurveyId: number.isRequired,
};

const mapStateToProps = ({ turnkeyOmnibus }) => {
  const { surveyInfo } = turnkeyOmnibus;
  return {
    gizmoSurveyId: surveyInfo.gizmoSurveyId,
  };
};

export default connect(
  mapStateToProps,
  null
)(SurveyGizmoIframe);
